module.exports = __webpack_public_path__ + "img/feature_buy_id.687c9bf2.png";